const r = "ms_app_modal";
function m(e) {
  let t, n;
  function o() {
    a(), e();
  }
  function c() {
    n = setTimeout(() => {
      o(), t = l(o);
    }, u(r));
  }
  function i() {
    clearTimeout(n), clearInterval(t);
  }
  return {
    startInterval: c,
    clearSessionInterval: i
  };
}
function u(e) {
  const t = window.localStorage.getItem(e);
  return t ? parseInt(t, 10) - Date.now() : 0;
}
function l(e) {
  return setInterval(() => {
    a(), e();
  }, 864e5);
}
function a() {
  window.localStorage.setItem(r, s());
}
function s() {
  return (Date.now() + 864e5).toString();
}
export {
  m as useStoredInterval
};
